import React, { useEffect } from 'react';
import './styles/main.scss';
import Router from '../src/router'
import { clearUrlToken } from './utils'

function App() {
  useEffect(() => {
    clearUrlToken();
  }, []);

  return (
    <Router />
  );
}

export default App;
